// extracted by mini-css-extract-plugin
export var description = "style-mod--description--2901d";
export var hero = "style-mod--hero--67eb9";
export var heroBody = "style-mod--hero-body--eca14";
export var heroCard = "style-mod--hero-card--be899";
export var heroContent = "style-mod--hero-content--7e0ce";
export var heroImage = "style-mod--hero-image--a9f28";
export var heroImageHover = "style-mod--hero-image-hover--43950";
export var heroImageStatic = "style-mod--hero-image-static--d2f68";
export var heroSubtitle = "style-mod--hero-subtitle--9ad7f";
export var heroTitle = "style-mod--hero-title--6ff4c";
export var heroes = "style-mod--heroes--07bf5";
export var shadow = "style-mod--shadow--a0368";
export var title = "style-mod--title--8b809";